import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { DASHBOARD_PATH } from 'config';
import Logo from 'ui-component/Logo';

const LogoSection = ({ onlyLogo }: any) => (
    <Link component={RouterLink} to={DASHBOARD_PATH}>
        {onlyLogo ? (
            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0887 8.36237H8.68357C8.32833 8.36237 8.04035 8.66189 8.04035 9.03136V14.8014C8.04035 15.1709 8.32833 15.4704 8.68357 15.4704H14.0828C17.6285 15.4704 20.5029 12.4809 20.5029 8.79316C20.5029 8.55524 20.3174 8.36237 20.0887 8.36237Z"
                    fill="white"
                />
                <path
                    d="M5.78905 8.36237H0.643228C0.287983 8.36237 0 8.66189 0 9.03136V17.7156C0 21.1864 2.70529 24 6.04244 24C6.25774 24 6.43228 23.8185 6.43228 23.5946V9.03136C6.43228 8.66189 6.14429 8.36237 5.78905 8.36237Z"
                    fill="white"
                />
                <path
                    d="M27.5102 0H13.1862C10.3442 0 8.04035 2.39613 8.04035 5.35192V6.02091C8.04035 6.39038 8.32833 6.6899 8.68357 6.6899H21.8576C25.1947 6.6899 27.9 3.87625 27.9 0.405448C27.9 0.181525 27.7255 0 27.5102 0Z"
                    fill="white"
                />
                <path
                    d="M14.631 17.0592H8.68357C8.32833 17.0592 8.04035 17.3587 8.04035 17.7282V23.5591C8.04035 23.8026 8.23015 24 8.46429 24H8.76641C12.2287 24 15.0354 21.0808 15.0354 17.4799C15.0354 17.2476 14.8544 17.0592 14.631 17.0592Z"
                    fill="white"
                />
                <path
                    d="M0 3.34495C0 5.19231 1.43991 6.6899 3.21614 6.6899C4.99236 6.6899 6.43228 5.19231 6.43228 3.34495C6.43228 1.49758 4.99236 0 3.21614 0C1.43991 0 0 1.49758 0 3.34495Z"
                    fill="white"
                />
            </svg>
        ) : (
            <Logo />
        )}
    </Link>
);

export default LogoSection;
